import { useState, useCallback, useEffect } from 'react';
import * as transportOrderManagementAction from "../../../redux/store-sarang/transport-order/transport-order-management.store";
import * as accountManagementAction from "../../../redux/store/account/account.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";

export const useTransportOrderData = (showLoading, configLocal, setValue, getValues) => {
    const [data, setData] = useState([]);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(configLocal.defaultPageSize);
    const [order, setOrder] = useState(configLocal.order);
    const [orderBy, setOrderBy] = useState(configLocal.orderBy);
    const [searchData, setSearchData] = useState();
    const [sumaryCuisine, setSumaryCuisine] = useState();

    const getListTransportOrderManagement = useCallback(async (pageIndex = 1, pageSize = rowsPerPage, sortExpression = configLocal.sortExpression, queryData = searchData) => {
        showLoading(true);
        try {
            const res = await transportOrderManagementAction.GetListTransportOrder(pageIndex, pageSize, sortExpression, queryData);
            if (res && res.content && res.content.items) {
                setData(res.content.items);
                setTotalItemCount(res.content.totalItemCount);
            }
            if (res) {
                setSumaryCuisine({
                    sumaryLunch: res.sumaryLunch,
                    sumaryDinner: res.sumaryDinner,
                    sumaryMorning: res.sumaryMorning,
                    sumaryCuisineQuatity: res.sumaryCuisine,
                    sumaryMorningOrder: res.sumaryMorningOrder,
                    sumaryLunchOrder: res.sumaryLunchOrder,
                    sumaryDinnerOrder: res.sumaryDinnerOrder,
                    sumaryCuisineOrder: res.sumaryCuisineOrder,
                    sumaryShipperLunch: res.sumaryShipperLunch,
                    sumaryShipperDinner: res.sumaryShipperDinner,
                    sumaryShipperMorning: res.sumaryShipperMorning,
                    sumaryShipperCuisine: res.sumaryShipperCuisine,
                });
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        } finally {
            showLoading(false);
        }
    }, [showLoading, rowsPerPage, searchData, configLocal.sortExpression]);

    const getUserDetail = useCallback(async () => {
        try {
            const res = await accountManagementAction.GetDetailAcc();
            if (res && res.content) {
                const branchId = res.content.branchId;
                if (branchId) {
                    setValue("branchId", branchId);
                    setSearchData(prev => ({ ...prev, branchId }));
                    getListTransportOrderManagement(1, rowsPerPage, configLocal.sortExpression, { ...getValues(), branchId });
                    return;
                }
            }
            getListTransportOrderManagement(1, rowsPerPage, configLocal.sortExpression, getValues());
        } catch (err) {
            getListTransportOrderManagement(1, rowsPerPage, configLocal.sortExpression, getValues());
        }
    }, [rowsPerPage, setValue, getValues, getListTransportOrderManagement, configLocal.sortExpression]);

    return {
        data, setData,
        totalItemCount, setTotalItemCount,
        page, setPage,
        rowsPerPage, setRowsPerPage,
        order, setOrder,
        orderBy, setOrderBy,
        searchData, setSearchData,
        sumaryCuisine, setSumaryCuisine,
        getListTransportOrderManagement,
        getUserDetail
    };
};
